import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { OperationLoadingState, OperationLockState, OperationsSlice } from "./types";

const initialState: OperationsSlice = {
	loadingState: [],
	lockState: [],
	lastCreatedProcessBusinessKey: undefined
};

export const {
	name: operationsSliceName,
	actions: {
		setOperationLoading,
		setOperationLock,
		removeOperationLock,
		clearOperationLock,
		setLastCreatedProcessBusinessKey
	},
	reducer: operationsReducer
} = createSlice({
	name: "operations",
	initialState,
	reducers: {
		setOperationLoading: (state, action: PayloadAction<OperationLoadingState>) => {
			const { operationName, loadingState, error } = action.payload;
			const existing = state.loadingState.find(op => op.operationName === operationName);

			if (existing) {
				existing.loadingState = loadingState;
				existing.error = error;
			} else {
				state.loadingState.push({ operationName, loadingState, error });
			}
		},
		setOperationLock: (state, action: PayloadAction<OperationLockState>) => {
			const { group, reference, userId, userFullName, lockedAt, lockExpiration } = action.payload;
			const existing = state.lockState.find(ls => ls.reference === reference);

			if (existing) {
				existing.group = group;
				existing.userId = userId;
				existing.userFullName = userFullName;
				existing.lockedAt = lockedAt;
				existing.lockExpiration = lockExpiration;
			} else {
				state.lockState.push({ group, reference, userId, userFullName, lockedAt, lockExpiration });
			}
		},
		removeOperationLock: (state, action: PayloadAction<{ reference: string }>) => {
			const { reference } = action.payload;
			state.lockState = state.lockState.filter(ls => ls.reference !== reference);
		},
		clearOperationLock: (state, action: PayloadAction<{ group: string | undefined }>) => {
			if (action.payload.group) {
				state.lockState = state.lockState.filter(ls => ls.group !== action.payload.group);
			} else {
				state.lockState = [];
			}
		},
		setLastCreatedProcessBusinessKey: (
			state,
			action: PayloadAction<{ lastCreatedProcessBusinessKey: string | undefined }>
		) => {
			state.lastCreatedProcessBusinessKey = action.payload.lastCreatedProcessBusinessKey;
		}
	}
});
